import React, { useState, useCallback } from 'react';
import BlogsCircleSelect from './blogs_circle_select';

const MyBlogsEditForm = ({ blogs, usersCircles, setUsersCircles }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCreateBlogClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSelectCircle = (selectedCircleId) => {
    window.location.href = `/my_circle/${selectedCircleId}/blogs/create`;
  };

  return (
    <div>
      <div className="container mt-4">
        <div className="d-flex justify-content-between my-4 align-items-center">
          <h2
            className="pl-2_5 mb-0 text-fw-bold h2 h2--extend -member2"
            style={{ fontSize: '18px' }}
          >
            ブログ一覧
          </h2>
          <button
            className="btn btn-info bg-green"
            style={{ height: '38px' }}
            onClick={handleCreateBlogClick}
          >
            ブログ作成
          </button>
        </div>
        {blogs && blogs.length > 0 ? (
          <div className="row">
            {blogs.map((blog) => (
              <div
                key={blog.id}
                className="mr-0 ml-0 px-0 pb-4 mb-4 row justify-content-center col-6 col-md-4"
              >
                {/* ブログの画像 */}
                <div className="rounded col-12 px-2">
                  <span
                    className={`${
                      blog.is_draft ? 'bg-black-50 text-white' : 'badge-danger'
                    } badge text-fw-bold px-2 py-1`}
                    style={{ top: '6%', left: '6%', position: 'absolute' }}
                  >
                    {blog.is_draft
                      ? '下書き'
                      : blog.public_type === 1
                      ? new Date(blog.publish_datetime) < new Date()
                        ? '公開'
                        : '未公開'
                      : 'サークル内公開'}
                  </span>
                  <img
                    className="card-img-top card-img-top--list_report_small rounded"
                    src={blog.image_url_medium || 'https://tunagate.com/images/ja2/img_noimage.gif'}
                    alt={blog.title || 'No Title'}
                    style={{ objectFit: 'contain' }}
                    onError={(e) => {
                      e.target.src = 'https://tunagate.com/images/ja2/img_noimage.gif';
                    }}
                  />
                </div>

                {/* ブログのタイトルとアクション */}
                <div className="col-12 px-3 py-2">
                  <h3 className="text-fw-bold mb-2 text-fz-13px pt-2 line-2 text-black-444">
                    {new Date(blog.publish_datetime) < new Date() ? (
                      <a href={`/blogs/${blog.id}`}>{blog.title}</a>
                    ) : (
                      blog.title
                    )}
                  </h3>
                  <div className="text-fz-14px text-fw-500 text-black-666 mb-2 d-flex justify-content-between">
                    <div>
                      <span className="mr-1">
                        <img
                          src={(blog.user && blog.user.avatar_medium) || '/default-avatar.png'}
                          className="rounded-circle"
                          alt="avatar"
                          style={{ height: '30px', objectFit: 'cover' }}
                        />
                      </span>
                      <span className="text-black-666">
                        {(blog.publish_datetime && blog.publish_datetime.substring(0, 10)) || 'No Date'}
                      </span>
                    </div>
                    {/* 編集ボタン */}
                    <div className="dropdown">
                      <img
                        src="/assets2019/img/icon_reader.svg"
                        alt="menu"
                        style={{ cursor: 'pointer', padding: '0 2px 0 12px' }}
                        data-toggle="dropdown"
                      />
                      <div
                        className="dropdown-menu"
                        style={{ width: 'auto', minWidth: '150px', padding: '2px' }}
                      >
                        <a
                          href={`/my_circle/${blog.circle_id}/blogs/${blog.id_to_param}/edit`}
                          className="dropdown-item text-black-666 btn btn-light rounded text-center"
                        >
                          編集する
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">ブログがありません。</p>
        )}
      </div>
      {/* モーダルの表示 */}
      {isModalOpen && (
        <BlogsCircleSelect
          blogsCircles={usersCircles}
          onSelectCircle={handleSelectCircle}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default MyBlogsEditForm;
